module.exports = __webpack_public_path__ + "static/media/intro.ed16080c.mp3";